var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Notification } from '../notification';
import { Back } from '../icon';
function ErrorNotification(_a) {
    var error = _a.error, onReset = _a.onReset;
    return (_jsx(Notification, { title: "Something went wrong", description: error === null || error === void 0 ? void 0 : error.message, variant: "error", action: _jsx(Notification.ActionButton, __assign({ onClick: onReset, iconRight: _jsx(Back, {}) }, { children: "Try Again" })) }));
}
export default ErrorNotification;
